<template>
    <div class="gutter frame login-view">
        <div class="login-form">
            <forgot-password></forgot-password>
            <div>
                <router-link to="/login">Login</router-link>
                <span> | </span>
                <router-link to="/register">New Account</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseView       from '../../../App/Views/BaseView';
    import ForgotPassword from './Auth/ForgotPassword';

    export default {
        components: { ForgotPassword },
        extends: BaseView,
    }
</script>
